import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'
import type {
  GetTranslationsRequest,
  GetTranslationsResponse,
  UpdateTranslationRequest,
  UpdateTranslationResponse,
  SyncMissingKeysRequest,
  SyncMissingKeysResponse,
  AlertMissingKeysRequest,
  AlertMissingKeysResponse
} from '../types/translations'

/**
 * Get translations for a language
 */
export const getTranslations = async (request: GetTranslationsRequest): Promise<GetTranslationsResponse> => {
  const getTranslationsFn = httpsCallable<GetTranslationsRequest, GetTranslationsResponse>(functions, 'getTranslations')
  const result = await getTranslationsFn(request)
  return result.data
}

/**
 * Update translations for a language (admin only)
 */
export const updateTranslation = async (request: UpdateTranslationRequest): Promise<UpdateTranslationResponse> => {
  const updateTranslationFn = httpsCallable<UpdateTranslationRequest, UpdateTranslationResponse>(
    functions,
    'updateTranslation'
  )
  const result = await updateTranslationFn(request)
  return result.data
}

/**
 * Sync missing keys to Firestore (for manual sync from Back Office)
 * Note: Auto-seeding has been removed. This function is kept for manual translation syncing.
 */
export const syncMissingKeys = async (request: SyncMissingKeysRequest): Promise<SyncMissingKeysResponse> => {
  try {
    const syncMissingKeysFn = httpsCallable<SyncMissingKeysRequest, SyncMissingKeysResponse>(
      functions,
      'syncMissingKeys'
    )
    const result = await syncMissingKeysFn(request)
    return result.data
  } catch (error) {
    console.error('[syncMissingKeys] ❌ Function call failed:', error)
    throw error
  }
}

/**
 * Alert missing keys to Slack (for monitoring)
 * Note: This function may not exist yet on the backend
 */
export const alertMissingKeys = async (request: AlertMissingKeysRequest): Promise<AlertMissingKeysResponse> => {
  try {
    const alertMissingKeysFn = httpsCallable<AlertMissingKeysRequest, AlertMissingKeysResponse>(
      functions,
      'alertMissingTranslationKeys'
    )
    const result = await alertMissingKeysFn(request)
    return result.data
  } catch (error) {
    // Function may not be deployed yet, return success to avoid breaking the app
    console.warn('[alertMissingKeys] Function not available:', error)
    return { success: false }
  }
}
